module.exports = __webpack_public_path__ + "img/data_organization_flatline.277c16cb.svg";